import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Menu, MenuApi, SideMenu } from '@modules/security/profile/models/menu';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MenuService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/menus';
	}

	public getMenuForLevel(level): Observable<Menu[]> {
		return this._restClientService.get(this.apiUrl + '?level=' + level);
	}

	public getApiByMenuId(id): Observable<MenuApi[]> {
		return this._restClientService.get(this.apiUrl + '/' + id + '/apis');
	}
	public getAllApiMenu(menusId: string[]): Observable<MenuApi[]> {
		return this._restClientService.get(this.apiUrl + '/' + menusId.join(',') + '/apis');
	}

	public getAllMenus(): Observable<Menu[]> {
		return this._restClientService.get(this.apiUrl);
	}

	public getSideBarMenu(): Observable<any> {
		return this._restClientService.get(this.apiUrl + '/side-bar');
	}

	public getSideBarMenuByAppId(): Observable<SideMenu> {
		return this._restClientService.get(this.apiUrl + '/side-bar-by-application-id');
	}
}
